import React, { useState, useEffect } from 'react';
import { searchDocuments, fetchDocument } from '../../../api/DocumentsAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import DocumentViewer from './DocumentViewer';
import './SearchPage.css';
import '../documents/Tiptap.css'; // <-- Import the Tiptap CSS file here

const SearchDocumentationPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [results, setResults] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearching, setIsSearching] = useState(false);

     useEffect(() => {
        // Initial load of all documents
        setIsSearching(true);
        searchDocuments('', (response) => {
            if (response.documents) {
                setResults(response.documents);
            }
            setIsSearching(false);
        });
    }, []);


    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setIsSearching(true);
            searchDocuments(searchTerm, (response) => {
                if (response.documents) {
                    setResults(response.documents);
                }
                setIsSearching(false);
            });
        }, 500); // Debounce search to avoid excessive API calls

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    const handleSelectDocument = (docId) => {
        setIsLoading(true);
        setSelectedDocument(null);
        fetchDocument(docId, (response) => {
            if (response.document) {
                setSelectedDocument(response.document);
            }
            setIsLoading(false);
        });
    };

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Search Documentation" />
                <div className="search-page-layout">
                    <aside className="search-sidebar">
                        <div className="search-bar">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search documents..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="search-results">
                             {isSearching && <div className="d-flex justify-content-center p-3"><div className="spinner-border spinner-border-sm" role="status"><span className="visually-hidden">Loading...</span></div></div>}
                            {!isSearching && results.length === 0 && <p className="p-3 text-muted">No results found.</p>}
                            <ul>
                                {results.map(doc => (
                                    <li key={doc.id} onClick={() => handleSelectDocument(doc.id)} className={selectedDocument?.id === doc.id ? 'active' : ''}>
                                        {doc.title}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </aside>
                    <section className="search-content">
                        {isLoading && <div className="d-flex justify-content-center align-items-center h-100"><div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div></div>}
                        {!isLoading && selectedDocument ? (
                            <DocumentViewer document={selectedDocument} />
                        ) : (
                             !isLoading && (
                                <div className="placeholder-content">
                                    <h5>Select a document to view its content</h5>
                                    <p>Start by typing in the search box to find relevant documentation, or select one from the list.</p>
                                </div>
                             )
                        )}
                    </section>
                </div>
            </div>
        </main>
    );
};

export default SearchDocumentationPage;

